import VehicleCoverage from './VehicleCoverage'

export default VehicleCoverage
